import { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal } from "ui/base/modal/Modal.jsx";
import { mediaSizes } from "ui/theme";
import { pixelTrackEvent } from "utils/facebookPixel.js";
import { ForgotPassword } from "./forgotPassword";
import { PasswordResetOtp } from "./resetOTP";
import { ResetPassword } from "./resetPassword";
import { ResetPasswordSuccess } from "./resetSuccess";

export const ForgotPasswordModal = ({
    show,
    handleClose,
    setSigninModal,
}) => {
    const [activeTab, setActiveTab] = useState("forgotPassword");
    const [email, setEmail] = useState(undefined);

    useEffect(() => {
        pixelTrackEvent("Showing Forgot Password Modal");
    }, []);

    const onClose = () => {
        setActiveTab("forgotPassword")
        setEmail(undefined);
        handleClose();
    };

    const getMaxWidth = (key) => {
        switch (key) {
            case "forgotPassword":
                return 450
            case "ResetOTP":
                return 450
            case "ResetPassword":
                return 500
            case "ResetSuccess":
                return 450
            default:
                return 600
        }
    }

    return (
        <Modal
            show={show}
            handleClose={onClose}
            maxWidth={getMaxWidth(activeTab)}
            widthPercentage={100}
        >
            <Container>
                <Tab active={activeTab === "forgotPassword"}>
                    <ForgotPassword
                        onBackToLogin={() => {
                            onClose();
                            setSigninModal(true);
                        }}
                        setActiveTab={setActiveTab}
                        setState={setEmail}
                    />
                </Tab>
                <Tab active={activeTab === "ResetOTP"}>
                    <PasswordResetOtp
                        setActiveTab={setActiveTab}
                        setState={setEmail}
                        email={email}
                    />
                </Tab>
                <Tab active={activeTab === "ResetPassword"}>
                    <ResetPassword
                        email={email}
                        setActiveTab={setActiveTab}
                    />
                </Tab>
                <Tab active={activeTab === "ResetSuccess"}>
                    <ResetPasswordSuccess
                        onBackToLogin={() => {
                            onClose();
                            setSigninModal(true);
                        }}
                    />
                </Tab>
            </Container>
        </Modal>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    width: 100%;
    height: 100%; 
    gap: 1rem;

    & > svg {
        width: 70px;
        height: 70px;
        display: none;
    }

    @media (width >= ${mediaSizes.lg}) {
        & > svg {
            width: 70px;
            height: 70px;
            display: flex;
        }
    }
`;

const Tab = styled.div`
    width: 100%;
    height: 100%;
    display: ${({ active }) => (active ? "flex" : "none")};
`;
